// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1Cm6o","colMin":"styles_colMin__1g5HY","colCheckbox":"styles_colCheckbox__wWSRK"};